import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=ca77e318&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=ca77e318&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../ui/comic_ai/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca77e318",
  null
  
)

export default component.exports